module.exports = __webpack_public_path__ + "img/list_Story_08.5fcf5538.jpeg";